var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.06,2.656c.082.071.214.243.189.359l-.532,3.171c.114.35.534.385.687.038l.497-2.807c1.682.819,2.759,2.486,2.933,4.342.01.106-.023.296.005.38.026.075.158.072.223.103.711.341.595,1.223-.157,1.425-.331.089-.834.136-1.186.177-2.402.283-5.111.304-7.523.092-.495-.043-1.988-.161-2.354-.372-.654-.377-.392-1.303.321-1.379-.028-1.985,1.152-3.91,2.936-4.768l.489,2.786c.136.419.738.31.699-.134-.087-.979-.464-2.064-.532-3.026-.018-.255.239-.488.486-.515.801.064,1.734-.086,2.519,0,.102.011.224.062.301.129Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.567,16.336v6.164H7.433v-6.164l1.253-.262c.196.25.375.508.613.721,1.611,1.44,4.766,1.44,6.386.014.251-.221.422-.477.629-.735l1.253.262Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.389,10.469c0,2.91-2.211,6.28-5.459,5.829-2.665-.37-4.317-3.327-4.32-5.829.419.046.839.109,1.26.148,2.374.219,4.945.225,7.319,0,.4-.038.8-.113,1.2-.148Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.388,17.344v5.156h-2.845c.018-1.924.963-3.701,2.446-4.889.118-.095.26-.209.399-.268Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.612,17.344c.022-.026.361.237.399.268,1.483,1.184,2.428,2.966,2.446,4.889h-2.845v-5.156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/Construction.458211bf8cb815080807e2bfa67b0fc6.svg";
export { ForwardRef as ReactComponent };